/**
 * Компонент защиты роутов: проверяет авторизацию и permissions
 * Перенаправляет на /login если не авторизован, на / если нет прав
 */
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { usePermissions } from '@/hooks/usePermissions';

interface ProtectedRouteProps {
  children: React.ReactNode;
  permission?: string;
  anyOf?: string[];
}

export function ProtectedRoute({ children, permission, anyOf }: ProtectedRouteProps) {
  const { isAuthenticated } = useAuth();
  const { can, canAny } = usePermissions();
  const location = useLocation();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (anyOf && anyOf.length > 0 && !canAny(...anyOf)) {
    return <Navigate to="/" replace />;
  }
  
  if (permission && !can(permission)) {
    return <Navigate to="/" replace />;
  }
  
  return <>{children}</>;
}

